export default __webpack_public_path__ + "static/media/accountant.ce220c2e.svg";